<template>
    <Modal @close="onClose">
        <template #content>
            <ModalStandard :uiTitle="titleLbl" :uiIsGlobal="false" :uiCancel="false" @close="onClose">
                <template #body>
                    <p>{{ descLbl | athT }}</p>
                    <slot name="content"></slot>
                </template>
                <template #footer>
                    <AthButton class="el--s-m el--t-primary"
                        @click="onContinue($event)"
                        :lbl="continueLbl" />
                </template>
            </ModalStandard>
        </template>
    </Modal>
</template>

<script>
import ModalStandard from '../modal-styles/Standard.vue';
import AthButton from '../../atoms/Button.vue';
import Modal from './Modal.vue';

export default {
    name: 'mead-standalone-info-modal',
    props: {
        /**
         * Title text (i18n key) displayed in the modal's header.
         */
        titleLbl: {type: String, default: ''},
        /**
         * Description text (i18n key) displayed in the modal body above the "content" slot.
         */
        descLbl: {type: String, default: ''},
        /**
         * Label text (i18n key) for the continue button.
         */
        continueLbl: {type: String, default: 'mead.labels.confirm'},
    },
    components: {Modal, ModalStandard, AthButton},
    methods: {
        onContinue: function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('continue');
        },
        onClose: function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('close');
        },
    },
};
</script>
